import { Organization } from '../interfaces';

export const MaxOrganizationLeaders = 10;

export function normalizeEntityName(name: string): string {
	return name.trim().toLowerCase();
}

export function isUniqueName(
	name: string,
	existingNames: Iterable<string>,
): boolean {
	const normalized = normalizeEntityName(name);
	if (!normalized) return true;

	for (const existing of existingNames) {
		if (normalizeEntityName(existing) === normalized) return false;
	}

	return true;
}

export function assignedDomains(
	organizations: Pick<Organization, 'domains'>[],
): Set<string> {
	const used = new Set<string>();
	for (const organization of organizations) {
		for (const domain of organization.domains ?? []) {
			const normalized = domain.trim().toLowerCase();
			if (normalized) used.add(normalized);
		}
	}
	return used;
}

export function availableDomains(
	allDomains: Iterable<string>,
	usedDomains: Set<string>,
	selectedDomains: Iterable<string> = [],
): string[] {
	const selected = new Set(
		Array.from(selectedDomains)
			.map((domain) => domain.trim().toLowerCase())
			.filter(Boolean),
	);

	return Array.from(allDomains).filter((domain) => {
		const normalized = domain.trim().toLowerCase();
		if (!normalized) return false;
		return !usedDomains.has(normalized) && !selected.has(normalized);
	});
}
